import { ProgramTypes } from 'legacy/lut/classes/models/ProgramTypes'
import { IApiCommitmentStatus } from 'legacy/lut/services/partner360/commitment/models/apiCommitmentStatus'

import { getTokens } from 'core/classes/helpers/StorageHelper'
import { proxy } from 'core/classes/helpers/UrlHelper'
import { HttpHeaders, Rest } from 'core/classes/http'

interface IRestoreAcknowledgement {
  partnerId: string
  fYear: number
  programType: ProgramTypes
  action?: string
}

export const planReview = async ({
  partnerId,
  fYear,
  programType,
  action,
}: IRestoreAcknowledgement): Promise<IApiCommitmentStatus[]> => {
  const url = proxy('/webservice/621/sp/v3/spJBPPlanReview/call')
  const [accessToken] = getTokens()
  const headers = new HttpHeaders()

  if (accessToken) {
    headers.add('Authorization', `Bearer ${accessToken}`)
  }

  const payload = {
    'p.PartnerId': partnerId,
    'p.FYear': fYear,
    'p.ProgramType': programType,
    'p.Action': action,
  }
  const response = await Rest.post({ url, payload, headers })

  return response.Rows ?? []
}
